/**
 * 消息缓冲工具
 * 管理流式输出过程中的消息状态
 */

let messageIdCounter = 0;

/**
 * 创建用户消息
 */
export function createUserMessage(content, options = {}) {
  return {
    id: `msg_${Date.now()}_${++messageIdCounter}`,
    role: 'user',
    content,
    time: formatTime(options.time || new Date()),
    status: 'sent',
    ...options
  };
}

/**
 * 创建助手消息占位
 */
export function createAssistantPlaceholder() {
  return {
    id: `msg_${Date.now()}_${++messageIdCounter}`,
    role: 'assistant',
    content: '',
    time: '',
    isStreaming: true,
    status: 'streaming',
    parsedContent: null
  };
}

/**
 * 更新流式消息内容
 */
export function updateStreamingMessage(message, chunk) {
  if (!message) return;
  message.content += chunk;
  return message;
}

/**
 * 完成流式消息
 */
export function finalizeMessage(message, conversationId = '') {
  if (!message) return;
  message.isStreaming = false;
  message.time = formatTime(new Date());
  message.status = 'done';
  if (conversationId) {
    message.conversationId = conversationId;
  }
  return message;
}

/**
 * 标记发送失败
 */
export function markMessageError(message, errorText = '') {
  if (!message) return;
  message.isStreaming = false;
  message.status = 'error';
  message.content = errorText || '抱歉，服务暂时不可用，请稍后再试。';
  message.time = formatTime(new Date());
  return message;
}

/**
 * 创建会话对象
 */
export function createConversation(id, title, options = {}) {
  return {
    id,
    title: title || `会话 ${formatDate(new Date())}`,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    messageCount: 0,
    ...options
  };
}

function formatTime(date) {
  if (!date) return '';
  const h = date.getHours().toString().padStart(2, '0');
  const m = date.getMinutes().toString().padStart(2, '0');
  return `${h}:${m}`;
}

function formatDate(date) {
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${month}-${day}`;
}
